import React from 'react';
import { KPICard, LoadingSpinner } from '../../ui';
import { formatNumber } from '../../../utils/formatters';
import { useRefineCustomerRegisteredReasons } from '../../../hooks/useRefineCustomerQueries';

import { KPIProps } from '../../../types/kpi';
const RegisteredReasonsKPI: React.FC<KPIProps> = ({
  branchId = 0,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data: registeredReasons, isLoading, error, refetch } = useRefineCustomerRegisteredReasons(branchId);

  React.useEffect(() => {
    if (error && onError) {
      onError(error as Error);
    }
  }, [error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (error || !registeredReasons) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری دلایل ثبت شده</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`${className} animate-enter-up stagger-3`}>
      <KPICard
        title="دلایل ثبت شده"
        value={formatNumber(registeredReasons?.total || 0)}
        subtitle={`مثبت: ${formatNumber(registeredReasons?.positive || 0)} | منفی: ${formatNumber(registeredReasons?.negative || 0)}`}
        variant="info"
        accentStyle="corner"
      />
    </div>
  );
};

export default RegisteredReasonsKPI;